import { isWeb } from '../targetCheck/targetCheck';

export const IPHONE_SE = {
  WIDTH: 320,
  HEIGHT: 568,
};

// This constant is for now only used to change style on home for devices
// smaller than Galaxy S6. Originaly, we used the size of iPhone SE but it was too restrictive
export const GALAXY_S6 = {
  WIDTH: 360,
  HEIGHT: 640,
};

// we use the iPhone SE which is the smallest device as base dimension to scale on bigger screens
export const DEVICE_BASE_DIMENSIONS = {
  width: IPHONE_SE.WIDTH,
  height: IPHONE_SE.HEIGHT,
};

export enum ESCALABLE_MODES {
  HEIGHT = 'height',
  WIDTH = 'width',
}

export const BREAKER_GRADIENT_HEIGHT_RATIO = 5;

/* ***** *****  Logic for the ratios  ***** ***** */

// Set the values to the reference device size
// to have a ratio of 1 by default
export const dimensions = {
  [ESCALABLE_MODES.HEIGHT]: 667,
  [ESCALABLE_MODES.WIDTH]: 375,
};

export const setupDocumentDimensions = () => {
  const isOnWam = isWeb();

  // if document.documentElement.clientHeight === 0, we are in a test.
  if (isOnWam && document.documentElement.clientHeight) {
    dimensions[ESCALABLE_MODES.HEIGHT] = document.documentElement.clientHeight;
    dimensions[ESCALABLE_MODES.WIDTH] = document.documentElement.clientWidth;
  } else {
    try {
      // const { Dimensions } = require('react-native');
      // const { width, height } = Dimensions.get('window');
      //
      // dimensions[ESCALABLE_MODES.HEIGHT] = height;
      // dimensions[ESCALABLE_MODES.WIDTH] = width;
    } catch (err) {
      // Can't load RN module
    }
  }

  getDeviceRatio();
};

export const dimensionsRatio = {
  [ESCALABLE_MODES.HEIGHT]: 1,
  [ESCALABLE_MODES.WIDTH]: 1,
};

const getDeviceRatio = () => {
  // Prevent the ratio to be applied for now on the app
  const isOnWam = isWeb();

  if (!isOnWam) return;

  // Prevent the ratio to be applied on phones larger than 650px (mainly for dev)
  if (dimensions[ESCALABLE_MODES.WIDTH] > 650) return;

  // Device de reference: iPhone 6/7/8
  const referenceDeviceHeight = 667;
  const referenceDeviceWidth = 375;

  if (dimensions[ESCALABLE_MODES.HEIGHT] !== referenceDeviceHeight) {
    dimensionsRatio[ESCALABLE_MODES.HEIGHT] =
      dimensions[ESCALABLE_MODES.HEIGHT] / referenceDeviceHeight;
  }

  if (dimensions[ESCALABLE_MODES.WIDTH] !== referenceDeviceWidth) {
    dimensionsRatio[ESCALABLE_MODES.WIDTH] =
      dimensions[ESCALABLE_MODES.WIDTH] / referenceDeviceWidth;
  }
};
